// extracted by mini-css-extract-plugin
export default {"genderIcon":"BodyDogHeader_genderIcon__njHy8","range":"BodyDogHeader_range__NeJqa","smallText":"BodyDogHeader_smallText__eTZBQ","genetics":"BodyDogHeader_genetics__j1apF"};